import { render, staticRenderFns } from "./CompanyTabBills.vue?vue&type=template&id=22a77c8d&scoped=true&"
import script from "./CompanyTabBills.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabBills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a77c8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
